import { useAuth } from "../../../context";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../utils/constants";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { IoPersonAddOutline } from "react-icons/io5";

function RegisterForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handleLogin } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState({ name: "", phoneNumber: "", password: "" });

  const set = (key) => (e) => setUserData(prev => ({ ...prev, [key]: e.target.value }));

  const register = async () => {
    setIsLoading(true);
    const response = await fetch(API_URL + '/register', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: userData.name,
        phone_number: userData.phoneNumber,
        password: userData.password,
      }),
    });
    const data = await response.json();
    if (data.success) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: 'user-id', userId: data.user.id, token: data.token })
        );
      }
      handleLogin(data);
      navigate(data.user.phone_verified_at ? "/" : "/otp");
    } else {
      toast.error(data.message || "حدث خطأ أثناء التسجيل");
    }
    setIsLoading(false);
  };

  const canSubmit = !isLoading && userData.name && userData.phoneNumber.length >= 8 && userData.password.length >= 8;

  return (
    <div>
      <div className="auth-group">
        <label className="auth-label">{t('auth.tabs.register.fields.fullname.label')}</label>
        <input
          className="auth-input"
          type="text"
          placeholder={t('auth.tabs.register.fields.fullname.placeholder')}
          value={userData.name}
          onChange={set('name')}
        />
      </div>

      <div className="auth-group">
        <label className="auth-label">{t('auth.tabs.register.fields.phone_number.label')}</label>
        <input
          className="auth-input"
          type="tel"
          inputMode="numeric"
          placeholder={t('auth.tabs.register.fields.phone_number.placeholder')}
          value={userData.phoneNumber}
          onChange={set('phoneNumber')}
        />
      </div>

      <div className="auth-group">
        <label className="auth-label">{t('auth.tabs.register.fields.password.label')}</label>
        <input
          className="auth-input"
          type="password"
          placeholder={t('auth.tabs.register.fields.password.placeholder')}
          value={userData.password}
          onChange={set('password')}
        />
        <p className="auth-help">{t('auth.tabs.register.fields.password.help_text')}</p>
      </div>

      <button className="auth-submit" onClick={register} disabled={!canSubmit}>
        {isLoading
          ? <span className="spinner-border spinner-border-sm" />
          : <IoPersonAddOutline size={20} />
        }
        {t('auth.tabs.register.button')}
      </button>
    </div>
  );
}

export default RegisterForm;
